@if (visibleTasks().length) {
    <div
        class="task-progress-container"
        role="region"
        aria-live="polite"
        [attr.aria-label]="'layout.backgroundTasks.header' | translate"
    >
        <div class="flex-column task-progress-card">
            @for (task of visibleTasks(); track task.id) {
                <div
                    class="flex-column gap task-progress-item"
                    [class.task-progress-item-completed]="
                        task.status === BackgroundTaskStatus.COMPLETED
                    "
                    [class.task-progress-item-failed]="
                        task.status === BackgroundTaskStatus.FAILED
                    "
                >
                    <div class="flex align-items-start gap-small">
                        <button
                            type="button"
                            class="flex flex-1 align-items-center gap-small task-summary"
                            (click)="openTasks.emit()"
                        >
                            <span
                                class="flex-column align-items-center justify-content-center task-status-icon"
                                aria-hidden="true"
                            >
                                <app-icon [icon]="icon(task)"></app-icon>
                            </span>
                            <span
                                class="flex-column flex-1 gap-x-small task-summary-text"
                            >
                                <span class="font-semibold">
                                    {{
                                        task.title
                                            | translate
                                            : (task.params
                                                | backgroundTaskParams)
                                    }}
                                </span>
                                @if (task.subtitle) {
                                    <span
                                        class="font-size-small text-color-secondary"
                                    >
                                        {{
                                            task.subtitle
                                                | translate
                                                : (task.params
                                                    | backgroundTaskParams)
                                        }}
                                    </span>
                                }
                            </span>
                        </button>
                        <app-button
                            icon="pi-times"
                            [severity]="'secondary'"
                            [text]="true"
                            (clickEvent)="store.dismissBubble(task.id)"
                        ></app-button>
                    </div>

                    @switch (task.status) {
                        @case (BackgroundTaskStatus.QUEUED) {
                            <span class="font-size-small text-color-secondary">
                                {{
                                    'layout.backgroundTasks.status.queued'
                                        | translate
                                }}
                            </span>
                        }
                        @case (BackgroundTaskStatus.RUNNING) {
                            <div class="flex-column gap-small">
                                <p-progress-bar
                                    [value]="task.progress"
                                    [showValue]="false"
                                    [style]="{ height: '4px' }"
                                ></p-progress-bar>
                                <div
                                    class="flex justify-content-between gap-small font-size-x-small text-color-secondary"
                                >
                                    <span>
                                        {{
                                            task.progressLabel ||
                                            'layout.backgroundTasks.status.running'
                                                | translate
                                                : (task.params
                                                    | backgroundTaskParams)
                                        }}
                                    </span>
                                    <span>
                                        {{ task.progress }}%
                                        @if (task.total) {
                                            ({{ task.done || 0 }}/{{
                                                task.total
                                            }})
                                        }
                                    </span>
                                </div>
                            </div>
                        }
                        @case (BackgroundTaskStatus.COMPLETED) {
                            <div class="flex-column gap-small">
                                <span class="font-size-small text-success">
                                    {{
                                        'layout.backgroundTasks.status.completed'
                                            | translate
                                    }}
                                </span>
                                @if (task.resultExpiresAt) {
                                    <span
                                        class="font-size-x-small text-color-secondary"
                                    >
                                        {{
                                            'layout.backgroundTasks.expiresAt'
                                                | translate
                                        }}
                                        {{
                                            task.resultExpiresAt
                                                | localDate: 'dd.MM.yyyy HH:mm'
                                        }}
                                    </span>
                                }
                                @if (task.resultFileId) {
                                    <div class="flex justify-content-end">
                                        <app-button
                                            [label]="resultAction(task)"
                                            [icon]="
                                                task.resultType ===
                                                BackgroundTaskResultType.PRINT
                                                    ? 'pi-external-link'
                                                    : 'pi-download'
                                            "
                                            [severity]="'primary'"
                                            [loading]="downloadingIds().has(task.id)"
                                            (clickEvent)="openResult(task)"
                                        ></app-button>
                                    </div>
                                }
                            </div>
                        }
                        @case (BackgroundTaskStatus.FAILED) {
                            <div class="flex-column gap-small">
                                <span class="font-size-small text-danger">
                                    {{
                                        'layout.backgroundTasks.status.failed'
                                            | translate
                                    }}
                                </span>
                                @if (task.errorMessage) {
                                    <span
                                        class="font-size-x-small text-color-secondary"
                                    >
                                        {{
                                            task.errorMessage
                                                | translate
                                                : (task.params
                                                    | backgroundTaskParams)
                                        }}
                                    </span>
                                }
                            </div>
                        }
                        @case (BackgroundTaskStatus.EXPIRED) {
                            <span class="font-size-small text-warning">
                                {{
                                    'layout.backgroundTasks.status.expired'
                                        | translate
                                }}
                            </span>
                        }
                    }
                </div>
            }

            @if (remainingCount() > 0) {
                <button
                    type="button"
                    class="task-more"
                    (click)="openTasks.emit()"
                >
                    {{
                        'layout.backgroundTasks.more'
                            | translate: { count: remainingCount() }
                    }}
                </button>
            }
        </div>
    </div>
}
